import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

/**
 * TODO: Mejorar rendering para manejar listas de +100 elementos de forma eficiente
 * TODO: Usar 'react-window' o librerías similares
 */

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  helperText: PropTypes.node,
  error: PropTypes.bool,
  label: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  classes: PropTypes.shape({}),
};

const defaultProps = {
  id: null,
  label: '',
  labelKey: null,
  valueKey: null,
  name: null,
  error: false,
  helperText: null,
  options: [],
  margin: 'normal',
  classes: {},
};

function DefaultSelect(props) {
  const {
    id, name, error, helperText, label, options, margin, labelKey, valueKey, classes, ...others
  } = props;

  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  const renderOptions = () => {
    const element = options.map(item => (
      <MenuItem
        key={valueKey ? item[valueKey] : item.value}
        value={valueKey ? item[valueKey] : item.value}
      >
        {labelKey ? item[labelKey] : item.label}
      </MenuItem>
    ));

    return element;
  };

  const renderedOptions = React.useMemo(() => renderOptions(), [options]);

  return (
    <FormControl classes={classes} variant="outlined" margin={margin} error={error} fullWidth>
      <InputLabel htmlFor={id} ref={inputLabel}>{label}</InputLabel>
      <Select
        input={
          <OutlinedInput name={name} labelWidth={labelWidth} id={id} />
        }
        {...others}
      >
        <MenuItem value="" disabled>
          <em>Seleccione</em>
        </MenuItem>
        { renderedOptions }
      </Select>
      {helperText && (
        <FormHelperText id={id}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

DefaultSelect.propTypes = propTypes;
DefaultSelect.defaultProps = defaultProps;

export default DefaultSelect;
